import React from 'react'

import classNames from 'classnames'

import styles from './MediaListArea.module.scss'

interface MediaListAreaProps {
  isTheme?: boolean
  isThemeMap?: boolean
  hasMultiple?: boolean
  children?: React.ReactNode
}

export const MediaListArea = ({ isTheme, isThemeMap = false, hasMultiple, children }: MediaListAreaProps) => {
  return (
    <div
      className={classNames(styles.photo_area, {
        [styles.type_multi]: hasMultiple,
        [styles.type_theme]: isTheme,
        [styles.type_theme_map]: isThemeMap,
      })}
    >
      {children}
    </div>
  )
}
